import { ApolloClient } from '@apollo/client'
import gql from 'graphql-tag'
import { IdentityServiceApi, TestRegistrationKey } from '../../../api'

export const QUERY = gql`
  query ListTestRegistrationKeys($limit: Int, $nextToken: String) {
    listTestRegistrationKeys(limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
      }
      nextToken
    }
  }
`

export async function listTestRegistrationKeys(
  client: ApolloClient<unknown>,
): Promise<TestRegistrationKey[]> {
  let items: TestRegistrationKey[] = []
  let nextToken

  do {
    const result: IdentityServiceApi['ListTestRegistrationKeysResult'] =
      await fetchTestRegistrationKeys(client, nextToken)
    nextToken = result.nextToken

    if (result.items) {
      items = items.concat(result.items)
    }
  } while (!!nextToken)

  return items
}

async function fetchTestRegistrationKeys(
  client: ApolloClient<unknown>,
  nextToken: string | undefined,
): Promise<IdentityServiceApi['ListTestRegistrationKeysResult']> {
  const result = await client.query<{
    listTestRegistrationKeys: IdentityServiceApi['ListTestRegistrationKeysResult']
  }>({
    query: QUERY,
    variables: {
      limit: 60,
      nextToken,
    },
    fetchPolicy: 'no-cache',
  })

  return result.data.listTestRegistrationKeys
}
